<template>
  <div class="cicFee">
    <!--      CIC费用  手续费、代理费、保险代理平台、投保金额、保险费-->
    <div class="nyTit"><i></i>{{$t('loan.cicFee')}}</div>
    <table border="0" cellpadding="0" cellspacing="0" class="tableCol2"  style="width: 1020px;">
      <tr>
        <td class="td1">{{$t('loan.poundage')}}：</td>
        <td class="td2">{{data.scCurrency}} {{data.serviceCharge | formatNum}}</td>
      </tr>
      <tr>
        <td class="td1">{{$t('loan.agencyFee')}}：</td>
        <td class="td2">{{data.afCurrency}} {{data.agencyFee | formatNum}}</td>
      </tr>
      <tr>
        <td class="td1">{{$t('loan.insuranceAgencyPlat')}}：</td>
        <td class="td2">{{data.insuranceAgent}}</td>
      </tr>
      <tr>
        <td class="td1">{{$t('loan.coverAmount')}}：</td>
        <td class="td2">{{data.iaCurrency}} {{data.insuranceAmount | formatNum}}</td>
      </tr>
      <tr>
        <td class="td1">{{$t('loan.insuranceFee')}}：</td>
        <td class="td2">{{data.ipCurrency}} {{data.insurancePremium | formatNum}}</td>
      </tr>

<!--      <tr>-->
<!--        <td class="td1"></td>-->
<!--        <td class="td2"></td>-->
<!--      </tr>-->
    </table>
  </div>
</template>
<script>
  export default {
    name: "cicFee",//cic费用
    props: ["data"],
    computed: {
      // 文件下载接口
      // fileUrl() {
      //   return `${this.axios.defaults.baseURL}/ctb/downFile?`;
      // },
    },
    data() {
      return {
        value: ''
      };
    },
    methods: {

    }
  };
</script>

<style lang="scss" scoped>

</style>

